export default __webpack_public_path__ + "static/media/adelaide.81d21c7c.svg";